import { cn } from "~/lib/utils";
import { type AnnualWheelEventColor } from "./types";

// Sets currentColor; the colours are in pins.css
export const eventColor: Record<AnnualWheelEventColor, string> = {
  blue: "text-(--pin-blue)",
  purple: "text-(--pin-purple)",
  pink: "text-(--pin-pink)",
  red: "text-(--pin-red)",
  yellow: "text-(--pin-yellow)",
};

export const EventSwatch = ({ color }: { color: AnnualWheelEventColor }) => (
  <span
    className={cn(
      "size-2.5 shrink-0 rounded-full bg-current",
      eventColor[color],
    )}
  />
);
